import { TFunction } from 'i18next';
import { capitalizeFirstLetter } from '@utils/strings/capitalizeFirstLetter';

/**
 * Generates the <Head> title for the job listing page.
 *
 * @param {TFunction} t - The translation function.
 * @param {string} locale - The current app locale.
 * @param {string} baseTitle - The base job list title.
 * @param {number} currentPage - The current page number.
 * @param {number} totalPages - The total number of pages available.
 * @returns {string} - The translated and formatted <Head> title.
 */
export const getJobListHeadTitle = (t: TFunction, locale: string, baseTitle: string) => {
  // Get the current month and year as a localized string
  const currentMonthYearString = new Date().toLocaleDateString(locale, { year: 'numeric', month: 'long' });

  // Initialize the array that will hold parts of the title
  const titleParts = [];

  // Add the base title and the current month/year
  titleParts.push(`${baseTitle} • ${capitalizeFirstLetter(currentMonthYearString)}`);

  // Add the site title
  titleParts.push('Bestjobs.eu');

  // Concatenate all the parts and return the final string
  return titleParts.join(' | ');
};
